import "./login-ext.css";
import BuckeyeLogo from "../../assets/img/svg/xloginbuckeyelogo.svg";
import RRDLogo from "../../assets/img/svg/xloginpagerrdlogo.svg";
import { useAuth } from "react-oidc-context";
import { useAuthToken } from "../../components/usecontext/AuthContext";

function LoginExt() {
  const auth = useAuth();
  const { accessToken, isAuthenticated } = useAuthToken();
  return (
    <>
      <div className="login-page-new-body-container">
        <div className="login-page-new-left-container">
          <div className="login-page-new-left-title">
            <img src={RRDLogo} alt="RRD Logo" />
            <h4>Welcome To BookIQ Application!</h4>
          </div>
          <div className="login-page-new-left-illustration"></div>
        </div>
        <div className="login-page-new-right-container">
          <div className="login-page-new-right-card-container">
            <div className="login-page-title-container">
              <div className="title-text">BookIQ</div>
            </div>
            <h2 className="login-page-new-right-card-title">
              Lets get started!
            </h2>
            <form action="">
              <div className="login-page-new-right-login-buttons">
                <div className="login-page-new-right-button-container rrduser">
                  <div className="login-page-new-right-button-icon">
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <ellipse
                        cx="8.33333"
                        cy="5.00008"
                        rx="3.33333"
                        ry="3.33333"
                        stroke="#FCFCFF"
                        strokeWidth="1.2"
                      />
                      <path
                        d="M10.8334 11.1058C10.0614 10.9301 9.2175 10.8333 8.33341 10.8333C4.65152 10.8333 1.66675 12.5122 1.66675 14.5833C1.66675 16.6543 1.66675 18.3333 8.33341 18.3333C10.6215 18.3333 12.9167 18.3333 13.7501 17.4999"
                        stroke="#FCFCFF"
                        strokeWidth="1.2"
                      />
                      <g clipPath="url(#clip0_471_4875)">
                        <ellipse
                          cx="14.1667"
                          cy="13.3332"
                          rx="4.16667"
                          ry="4.16667"
                          stroke="#FCFCFF"
                          strokeWidth="1.2"
                        />
                        <path
                          d="M12.5 13.3333C14.4526 13.3333 13.8807 13.3333 15.8333 13.3333M15.8333 13.3333L14.5833 12.0833M15.8333 13.3333L14.5833 14.5833"
                          stroke="#FCFCFF"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_471_4875">
                          <rect
                            width="10"
                            height="10"
                            fill="white"
                            transform="translate(9.16675 8.33325)"
                          />
                        </clipPath>
                      </defs>
                    </svg>
                  </div>
                  <button
                    className="login-page-new-right-button"
                    style={{ cursor: "auto" }}
                  >
                    Welcome
                  </button>
                </div>
                <div className="login-page-new-right-button-container externaluser">
                  <div className="login-page-new-right-button-icon">
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <ellipse
                        cx="8.33333"
                        cy="5.00008"
                        rx="3.33333"
                        ry="3.33333"
                        stroke="#FCFCFF"
                        strokeWidth="1.2"
                      />
                      <path
                        d="M10.8334 11.1058C10.0614 10.9301 9.2175 10.8333 8.33341 10.8333C4.65152 10.8333 1.66675 12.5122 1.66675 14.5833C1.66675 16.6543 1.66675 18.3333 8.33341 18.3333C10.6215 18.3333 12.9167 18.3333 13.7501 17.4999"
                        stroke="#FCFCFF"
                        strokeWidth="1.2"
                      />
                      <g clipPath="url(#clip0_471_4875)">
                        <ellipse
                          cx="14.1667"
                          cy="13.3332"
                          rx="4.16667"
                          ry="4.16667"
                          stroke="#FCFCFF"
                          strokeWidth="1.2"
                        />
                        <path
                          d="M12.5 13.3333C14.4526 13.3333 13.8807 13.3333 15.8333 13.3333M15.8333 13.3333L14.5833 12.0833M15.8333 13.3333L14.5833 14.5833"
                          stroke="#FCFCFF"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_471_4875">
                          <rect
                            width="10"
                            height="10"
                            fill="white"
                            transform="translate(9.16675 8.33325)"
                          />
                        </clipPath>
                      </defs>
                    </svg>
                  </div>
                  <button
                    className="login-page-new-right-button"
                    onClick={() => auth.signinRedirect()}
                  >
                    Login
                  </button>
                </div>
              </div>
            </form>
            <div className="login-page-new-right-footer">
              <p>
                Copyright © 2026 R.R.Donnelley & Sons Company. All rights
                reserved.
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* <div className="card">
      <h2>Authentication</h2>
      <div className="button-container">
        <a className="auth-button" href={CommonObj.Endpoints.Login}>
          Sign in
        </a>
        <a className="auth-button" href={CommonObj.Endpoints.Logout}>
          Sign out
        </a>
        {/* <button className="auth-button" onClick={UserLogin}>
          Auth
        </button> */}
      {/* </div>
              <div>{token?.output ? JSON.stringify(token?.output, null, 2) : "No token received"}</div> 
    </div> */}
    </>
  );
}

export default LoginExt;
